/**
 * ToggleLanguage Stateless Component
 */
import { get } from "lodash";
import * as React from "react";
import {
  LocalizeContextProps,
  Translate,
  withLocalize,
} from "react-localize-redux";
import { connect } from "react-redux";
import { Col, Container, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import {
  IHelpersActionCreator,
  setShowLanguageModal,
} from "root/store/helpers/ActionCreators";
import { IHelpersState } from "root/store/helpers/Reducer";
import { ICajitaStore } from "types/cajita_store";

interface ILanguageModalProps {
  openModal: boolean;
}

interface ILanguageModalFunc {
  showModal: (show: boolean) => void;
}

export type LangugeModalProps = ILanguageModalProps &
  ILanguageModalFunc &
  LocalizeContextProps;

/**
 * ToggleLanguage Stateless Component
 */
class LanguageModal extends React.Component<LangugeModalProps> {
  private img_path: string = "/assets/images/";

  constructor(props: LangugeModalProps) {
    super(props);
  }

  public render(): React.ReactNode {
    const row_class: string = "modal-language-row";

    return (
      <div>
        <Modal
          id="full-language-modal"
          className="language-modal"
          contentClassName="language-modal"
          isOpen={this.props.openModal}
        >
          <ModalHeader toggle={(): void => this.props.showModal(false)}>
            <div className="text-center modal-title">
              <h5>
                <Translate id="footer.changeLanguage" />
              </h5>
            </div>
          </ModalHeader>
          <ModalBody className="language-modal-body">
            <Container fluid={true}>
              <Row
                id="es-row"
                className={this._checkRowClass("es")}
                onClick={(): void => this._changeLanguage("es")}
              >
                <Col xs={2} sm={1} md={1} lg={1} xl={1}>
                  <div className={row_class}>
                    <img alt="es-flag" src={`${this.img_path}sm-flag-es.png`} />
                  </div>
                </Col>
                <Col xs={10} sm={11} md={11} lg={11} xl={1}>
                  <div className={row_class}>
                    <Translate id="languages.es" />
                  </div>
                </Col>
              </Row>
              <Row
                id="en-row"
                className={this._checkRowClass("en")}
                onClick={(): void => this._changeLanguage("en")}
              >
                <Col xs={2} sm={1} md={1} lg={1} xl={1}>
                  <div className={row_class}>
                    <img alt="en-flag" src={`${this.img_path}sm-flag-en.png`} />
                  </div>
                </Col>
                <Col xs={10} sm={11} md={11} lg={11} xl={11}>
                  <div className={row_class}>
                    <Translate id="languages.en" />
                  </div>
                </Col>
              </Row>
              <Row
                id="br-row"
                className={this._checkRowClass("br")}
                onClick={(): void => this._changeLanguage("br")}
              >
                <Col xs={2} sm={1} md={1} lg={1} xl={1}>
                  <div className={row_class}>
                    <img alt="br-flag" src={`${this.img_path}sm-flag-br.png`} />
                  </div>
                </Col>
                <Col xs={10} sm={11} md={11} lg={11} xl={11}>
                  <div className={row_class}>
                    <Translate id="languages.br" />
                  </div>
                </Col>
              </Row>
            </Container>
          </ModalBody>
        </Modal>
      </div>
    );
  }

  private _checkRowClass(language: string): string {
    return get(this, "props.activeLanguage.code", "es") === language
      ? "language-row-active"
      : "language-row-inactive";
  }

  private _changeLanguage(language: string): void {
    this.props.setActiveLanguage(language);
    this.props.showModal(false);
  }
}

const mapStateToProps: (state: ICajitaStore) => ILanguageModalProps = (
  state: ICajitaStore
): ILanguageModalProps => ({
  openModal: state.helpers.showModalLanguage,
});

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<IHelpersState, undefined, IHelpersActionCreator>
): object => ({
  showModal: (show: boolean): IHelpersActionCreator =>
    dispatch(setShowLanguageModal(show)),
});

const LanguageModalComponent: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(withLocalize<LocalizeContextProps>(LanguageModal));

export { LanguageModalComponent };



// WEBPACK FOOTER //
// ./src/components/UI/Toggle/LanguageModal.tsx